// import external dependencies
import 'jquery';
import '../../../node_modules/flickity/dist/flickity.pkgd';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import hasPager from './routes/pager';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,

  // Pager
  hasPager,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js